export const Store = {
    state: {
        nbProductsInBasket: 0 as number,
        culture: "nl-BE",
        loggedInUser: {
            loggedInAs: {}
        } as any,
        relativeTimeLocale: {} as any
    }
}